import { connect } from "react-redux";
import RightSidebar from "~/components/RightSidebar/RightSidebar";

import {
  toggleSidebarRight,
  selectRightSidebarIsOpen,
  selectIsDlsActive,
  selectIsPresentationActive
} from "~/store/ducks/user/uistate";

import { selectIsSidebarRightVisible } from "~/store/ducks/domain/ui/sidebarRight";

import { selectIsMaterialLayerEnabled } from "~/store/ducks/domain/ui/materialLayer";
import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";

function mapStateToProps(state) {
  return {
    isDlsActive: selectIsDlsActive(state),
    isOpen: selectRightSidebarIsOpen(state),
    isDocked: selectIsGreaterThanMedium(state),
    isMaterialVisible: selectIsMaterialLayerEnabled(state),
    isRightSidebarVisible: selectIsSidebarRightVisible(state),
    isPresentationActive: selectIsPresentationActive(state)
  };
}

const mapDispatchToProps = {
  toggleSidebarRight
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSidebar);
